import {
    BroadcastViewership,
    CommonKey,
    SearchParams,
    Client,
} from '../../types/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { useRightsholderAttribution } from './useRightsholderAttribution';

const getBroadcastsViewership = async (
    clientId,
    searchParams: any = {},
    pagination: { perPage: number; startIndex: number },
    useRightsholderAttribution: boolean,
) => {
    const body = {
        domainObject: {
            ...searchParams,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
        },
        ...pagination,
    };

    const response = await sportsApi
        .url(`/clients/${clientId}/broadcasts/viewership`)
        .post(body)
        .json();

    return response;
};

export const useBroadcastsViewership = (
    clientId: number,
    searchParams: SearchParams,
    pagination: { perPage: number },
    client?: Client | null,
) => {
    const { rightsholderAttribution } = useRightsholderAttribution({ client });

    return useInfiniteQuery({
        queryKey: [
            CommonKey.BroadcastViewership,
            clientId,
            searchParams,
            rightsholderAttribution,
        ],
        queryFn: ({ pageParam = 0 }) =>
            getBroadcastsViewership(
                clientId,
                searchParams,
                {
                    ...pagination,
                    startIndex: pageParam,
                },
                rightsholderAttribution === 'league',
            ),
        getNextPageParam: (lastPage: BroadcastViewership[], allPages) => {
            if (!lastPage) return 0;
            return lastPage.length === pagination.perPage
                ? allPages.length * pagination.perPage
                : undefined;
        },
        getPreviousPageParam: (firstPage: BroadcastViewership[], allPages) => {
            if (!firstPage) return 0;
            return allPages.length > 1
                ? (allPages.length - 2) * pagination.perPage
                : undefined;
        },
        staleTime: Infinity,
    });
};
